import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../autenticacao/auth.service';
import { CadastroService } from '../cadastro/cadastro.service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioDataNascimentoService {

  constructor(
    private authService: AuthService,
    private cadastroService: CadastroService) { }

  usuarioLogadoPrecisaDataNascimento(): boolean {

    const usuario: any = this.authService.usuarioLogado;

    return !!(usuario && usuario.id && !usuario.dataNascimento);

  }

  atualizarDataNascimentoUsuarioLogado(dataNascimento: string): Observable<boolean> {

    const usuario: any = this.authService.usuarioLogado;
    const dataNascimentoNormalizada = dataNascimento.trim();

    return this.cadastroService.atualizarDataNascimento(usuario.id, dataNascimentoNormalizada).pipe(
      map((usuarioAtualizado: any) => {
        const novaDataNascimento = usuarioAtualizado && usuarioAtualizado.dataNascimento
          ? usuarioAtualizado.dataNascimento
          : dataNascimentoNormalizada;

        this.authService.atualizarDataNascimentoUsuarioLogado(
          novaDataNascimento,
          usuarioAtualizado ? usuarioAtualizado.prioridadePessoaIdosa : undefined
        );
        return true;
      })
    );

  }

  dataNascimentoValida(dataNascimento: string): boolean {

    if (!/^\d{4}-\d{2}-\d{2}$/.test(dataNascimento)) {
      return false;
    }

    const partes = dataNascimento.split('-').map(valor => Number(valor));
    const data = new Date(partes[0], partes[1] - 1, partes[2]);
    const dataAtual = new Date();
    dataAtual.setHours(0, 0, 0, 0);

    return !isNaN(data.getTime())
      && data.getFullYear() === partes[0]
      && data.getMonth() === partes[1] - 1
      && data.getDate() === partes[2]
      && data <= dataAtual;

  }

}
